import * as React from 'react';

import { translate } from '~l10n/client';

import { Direction } from '~shared/utils/sort';

import { Ascending, Descending } from './ResultsGridIcons';

interface IndicatorProps {
  direction: Direction;
}

/**
 * Renders the correct icon based on sort direction.
 */
export function ResultsSortIndicator({
  direction,
}: IndicatorProps): React.ReactElement {
  switch (direction) {
    case Direction.Ascending:
      return (
        <>
          <span className="sr-only">{translate(Direction.Ascending)}</span>
          <Ascending />
        </>
      );
    case Direction.Descending:
      return (
        <>
          <span className="sr-only">{translate(Direction.Descending)}</span>
          <Descending />
        </>
      );
    default: {
      return <></>;
    }
  }
}
